// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6g_OO","controls":"styles_controls__D23iz","charLimit":"styles_charLimit__18PBe","input":"styles_input__1GPG6","send":"styles_send__2hgwT"};